import { render, staticRenderFns } from "./staff-minimal.vue?vue&type=template&id=3253fed4&scoped=true&"
import script from "./staff-minimal.vue?vue&type=script&lang=js&"
export * from "./staff-minimal.vue?vue&type=script&lang=js&"
import style0 from "./staff-minimal.vue?vue&type=style&index=0&id=3253fed4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3253fed4",
  null
  
)

export default component.exports